// src/components/register/RegistrationTypeTabs.jsx
const RegistrationTypeTabs = ({ type, onChange }) => {
  return (
    <div className="mb-8">
      <div className="flex bg-gray-100 rounded-lg p-1">
        <button
          type="button"
          onClick={() => onChange("user")}
          className={`flex-1 py-2 px-4 text-sm font-medium rounded-md transition-all duration-200 ${
            type === "user"
              ? "bg-white text-blue-600 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          Regular User
        </button>
        <button
          type="button"
          onClick={() => onChange("office")}
          className={`flex-1 py-2 px-4 text-sm font-medium rounded-md transition-all duration-200 ${
            type === "office"
              ? "bg-white text-blue-600 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          Office Registration
        </button>
      </div>
    </div>
  );
};

export default RegistrationTypeTabs;